import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';

import { DeveloperService, EnvironmentService } from '@core/services';

@Component({
  selector: 'z-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  constructor(public developerService: DeveloperService, public environmentService: EnvironmentService) {}

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.environmentService.environment.production) {
      return;
    }

    if (event.key === 'S' && event.ctrlKey && event.shiftKey) {
      this.developerService.clearState();
    }

    if (event.key === 'F4') {
      this.developerService.toggleTheme();
    }

    if (event.key === 'F9') {
      this.developerService.toggleLanguage();
    }
  }
}
